/**
 * Runs an array of async tasks with a bounded number in flight at once, preserving
 * completion but not order. A fixed pool of `limit` runners pulls from a shared cursor,
 * so exactly `limit` tasks are in flight until the queue drains — unlike fixed batches,
 * a slow task never idles the other slots.
 *
 * The worker returns `void`: callers accumulate results via side effects (writing into a
 * shared Map or counter), which is safe under JavaScript's single-threaded model.
 *
 * Used to fan out sibling WorkDocs folder-group creates within a BFS level.
 */
export async function runWithConcurrency<T>(items: T[], limit: number, worker: (item: T) => Promise<void>): Promise<void> {
  let cursor = 0;
  const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (cursor < items.length) {
      const index = cursor;
      cursor += 1;
      await worker(items[index]);
    }
  });
  await Promise.all(runners);
}
